import { render, staticRenderFns } from "./gSide.vue?vue&type=template&id=5f719067&scoped=true"
import script from "./gSide.vue?vue&type=script&lang=js"
export * from "./gSide.vue?vue&type=script&lang=js"
import style0 from "./gSide.vue?vue&type=style&index=0&id=5f719067&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f719067",
  null
  
)

export default component.exports